import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-[#F7F5F0]/30 py-3 text-[#F7F5F0] placeholder-[#F7F5F0]/40 focus:outline-none focus:border-[#D4AF37] transition-colors";

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center px-6">
      <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm">
        <p className="label-caps text-[#D4AF37] mb-3">Admin</p>
        <h1 className="font-serif-display text-4xl font-light text-[#F7F5F0] mb-10">Sign in to manage content.</h1>
        <div className="space-y-8">
          <div>
            <label className="label-caps text-[0.65rem] text-[#F7F5F0]/50">Email</label>
            <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="ayresacting@yahoo.com" />
          </div>
          <div>
            <label className="label-caps text-[0.65rem] text-[#F7F5F0]/50">Password</label>
            <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </div>
        </div>
        <button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full mt-10 bg-[#7A1C28] text-white hover:bg-[#5C151E] transition-colors px-8 py-4 label-caps text-[0.7rem] disabled:opacity-60">
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <button type="button" onClick={() => navigate("/")} className="w-full mt-4 label-caps text-[0.65rem] text-[#F7F5F0]/50 hover:text-[#F7F5F0]">
          ← Back to site
        </button>
      </form>
    </div>
  );
}
